import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class Pnd1korProvider {

  private _service: string = 'payroll';
  private _model: string = 'pnd1Kor';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public doDetail(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'doDetail';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public doSummary(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'doSummary';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/pnd1kor/pnd1kor.ts